/**
 * ScrollToTop Component
 * 
 * A utility component that automatically scrolls the window to the top
 * whenever the route changes. This ensures that new pages always start
 * at the top of the viewport.
 * 
 * Usage:
 * Place this component inside your Router component in App.js
 * 
 * Features:
 * - Automatically detects route changes using useLocation
 * - Scrolls to top on every navigation
 * - No visual rendering (returns null)
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when the route changes
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null; // This component doesn't render anything
}

export default ScrollToTop; 